import React from 'react';
import { motion } from 'framer-motion';
import { Award, Zap, CheckCircle2, Trophy } from 'lucide-react';
import { Linkedin, Youtube, Instagram } from 'lucide-react';
import { SOCIAL } from '../../data/content';

const BADGES = [
  { icon: Award, label: 'Claude AI Expert', pos: '-left-4 top-10' },
  { icon: Zap, label: '8+ Years Production ML', pos: 'right-0 top-24' },
  { icon: CheckCircle2, label: 'Fortune 500 Track Record', pos: 'right-2 bottom-10' },
  { icon: Trophy, label: '30 Under 30 · 2023', pos: 'left-1/2 -translate-x-1/2 -top-4' },
];

export default function About() {
  return (
    <section id="about" className="relative py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 items-center">
        {/* Photo with floating badges */}
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] w-full max-w-md mx-auto rounded-3xl overflow-hidden glass">
            <img
              src="/photo.png"
              alt="Parth Sharma"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0f] via-transparent to-transparent" />
          </div>

          {BADGES.map((b, i) => (
            <motion.div
              key={b.label}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ delay: 0.1 * i, duration: 0.5 }}
              className={`hidden md:flex absolute ${b.pos} items-center gap-2 glass-strong rounded-full px-3 py-2 shadow-lg`}
              data-testid={`about-badge-${i}`}
            >
              <b.icon size={14} className="text-teal" />
              <span className="font-mono text-[11px] uppercase tracking-[0.1em] text-white/90 whitespace-nowrap">
                {b.label}
              </span>
            </motion.div>
          ))}
        </div>

        {/* Copy */}
        <div className="lg:col-span-7">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-teal mb-6">
            About · Credibility
          </p>
          <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tighter">
            The Practitioner<br />
            Who Actually<br />
            <span className="text-teal">Builds What He Teaches.</span>
          </h2>
          <div className="mt-8 space-y-5 text-white/75 text-base md:text-lg leading-relaxed max-w-2xl">
            <p>
              Most AI trainers teach slides. I've architected LLM-powered document intelligence
              platforms that saved <span className="text-white font-semibold">€250K</span> and cut
              turnaround from <span className="text-white font-semibold">7 days to 2</span>.
            </p>
            <p>
              I've built pipelines processing <span className="text-white font-semibold">18,000+
              documents</span> for Fortune 500 banking clients and contributed to IndicTrans2 —
              India's national multilingual AI initiative supporting 30+ languages.
            </p>
            <p className="text-white/90">
              When I train your team, I'm not teaching theory. I'm showing you exactly what I
              built in production — and how to replicate it.
            </p>
          </div>

          <div className="mt-10">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40 mb-3">
              Follow my work
            </p>
            <div className="flex flex-wrap gap-3">
              <a href={SOCIAL.youtube} target="_blank" rel="noopener noreferrer" data-testid="about-yt" className="chip hover:border-[#FF0000]/60 hover:text-[#FF5555]">
                <Youtube size={13} /> @beardandbinary
              </a>
              <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" data-testid="about-ig" className="chip hover:border-[#E1306C]/60 hover:text-[#F77787]">
                <Instagram size={13} /> @beardandbinary
              </a>
              <a href={SOCIAL.linkedin} target="_blank" rel="noopener noreferrer" data-testid="about-li" className="chip hover:border-[#0A66C2]/60 hover:text-[#5aa9ff]">
                <Linkedin size={13} /> /parthsharma1011
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
